 const constants = {

    Save_Password: 'Save Password',

};
export default constants ;